<template>
    <div class="menu">
        <div ref="sideNav" class="bm-menu">
            <nav class="bm-item-list">
              <slot></slot>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
  name: 'menubar',
  data () {
    return {
      isSideBarOpen: true
    }
  },
  props: { // TODO : DT - nettoyer les props inutiles; documenter les props utiles
  },
  methods: {
  }
}
</script>
